export default {"src":"/_next/static/media/call.013c27cb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};